export const backendURL = 'https://admin-test.innoschool-learningsystem.eu';
export const apiURL     = backendURL + '/api';
export const storageURL = backendURL + '/storage';


